var styles = {
  "Container": "_Container_8b5v1_1",
  "SVG": "_SVG_8b5v1_5"
};

export { styles as default };
